module.exports = __webpack_public_path__ + "img/reports.a75a1572.svg";